import React, { useMemo, useState } from "react";
import "./../Styles/calculate.css";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";

const productImages = {
  Saree: "saree",
  Kurti: "kurti",
  Blouse: "blouse",
  Dupatta: "duptta",
  Lehenga: "lahenga",
};

// Define default sections tailored per category with all values initialized to 0
const categoryDefaults = {
  Saree: [
    { section: "Pallu", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    { section: "Border", area: 0, stitch: 0, heads: 0, workMeter: 0 },
  ],

  Kurti: [
    { section: "Neck", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    { section: "Sleeves", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    // { section: "Daman", area: 0, stitch: 0, heads: 0, workMeter: 0 },
  ],
  Blouse: [
    { section: "Back Neck", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    { section: "Sleeves", area: 0, stitch: 0, heads: 0, workMeter: 0 },
  ],
  Dupatta: [
    { section: " Buti", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    // { section: "Four-Side Border", area: 0, stitch: 0, heads: 0, workMeter: 0 },
  ],
  Lehenga: [
    { section: "Kali", area: 0, stitch: 0, heads: 0, workMeter: 0 },
    // { section: "Waist Belt", area: 0, stitch: 0, heads: 0, workMeter: 0 },
  ],
};
function DynamicImage({ name, defaultImage, alt, className, ...props }) {
  const extensions = [
    "jpg",
    "jpeg",
    "png",
    "webp",
    "gif",
    "svg",
    "avif",
    "jfif",
    "bmp",
  ];

  const [index, setIndex] = useState(0);

  const imageSrc =
    index < extensions.length
      ? `/images/Calculate/${name}.${extensions[index]}`
      : defaultImage;

  const handleError = () => {
    if (index < extensions.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  return (
    <img
      {...props}
      src={imageSrc}
      alt={alt || name}
      className={className}
      onError={handleError}
    />
  );
}
export default function Calculate() {
  const [product, setProduct] = useState("Saree");

  const [rows, setRows] = useState(categoryDefaults["Saree"]);

  const [rate, setRate] = useState("");
  const [area, setArea] = useState("");
  // Handles changing category and updating defaults seamlessly
  const handleProductChange = (selectedProduct) => {
    setProduct(selectedProduct);
    setRows(categoryDefaults[selectedProduct] || []);
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        section: "New Section",
        area: 0,
        stitch: 0,
        heads: 0,
        workMeter: 0,
      },
    ]);
  };

  const removeRow = (i) => {
    setRows(rows.filter((_, index) => index !== i));
  };

  const clearAllRows = () => {
    setRows([]);
  };

  const updateRow = (i, field, value) => {
    const updated = rows.map((row, index) => {
      if (index === i) {
        const newRow = {
          ...row,
          [field]: field === "section" ? value : value,
        };

        return newRow;
      }
      return row;
    });

    setRows(updated);
  };
  const calc = useMemo(() => {
    let totalStitch = 0;
    let totalArea = 0;
    let totalHeads = 0;
    let totalCost = 0;
    let totalMeter = 0;

    // ✅ ADD HERE

    const rateNum = parseFloat(rate) || 0;
    const areaInMeter = (parseFloat(area) || 0) / 1000;
    const enriched = rows.map((r) => {
      const stitch = Number(r.stitch) || 0;
      const heads = Number(r.heads) || 0;

      const cost = (stitch * heads * rateNum) / 1000;
      const workMeter = heads * areaInMeter;

      totalStitch += stitch;
      totalArea += Number(r.area) || 0;
      totalHeads += heads;
      totalCost += cost;
      totalMeter += workMeter;

      return { ...r, cost, workMeter };
    });

    return {
      rows: enriched,
      totalStitch,
      totalArea,
      totalHeads,
      totalCost,
      totalMeter,
    };
  }, [rows, rate, area]);
  return (
    <div className="calc-wrapper">
      <div className="calc-main-layout">
        {/* LEFT IMAGE */}
        <div className="calc-left" data-aos="fade-right">
          <div className="image-container big-image">
            <DynamicImage name={productImages[product]} alt={product} />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="calc-right" data-aos="fade-left">
          {/* HEADER ROW */}
          <div className="calc-header" data-aos="fade-down">
            <div className="left">
              <h2>Calculate Embroidery Work Costing</h2>
              <p className="subtitle"></p>

              <div className="controls">
                <div
                  className="control-group"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <label>Product Type</label>
                  <select
                    value={product}
                    onChange={(e) => handleProductChange(e.target.value)}
                  >
                    {Object.keys(productImages).map((p) => (
                      <option key={p}>{p}</option>
                    ))}
                  </select>
                </div>

                <div
                  className="control-group"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <label>Rate (per 1000 stitches)</label>
                  <div className="input-currency-wrapper">
                    <span className="currency-symbol1">₹</span>

                    <input
                      type="number"
                      step="0.01"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                </div>
                <div
                  className="control-group"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <label>Total Area (mm)</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* BODY ROW (TABLE + SUMMARY SIDE BY SIDE) */}
          <div className="calc-body-grid">
            {/* TABLE */}
            <div className="table-box" data-aos="fade-up" data-aos-delay="200">
              <div className="table-header-actions">
                <h3>Calculate Here</h3>
                <div
                  className="action-buttons-group"
                  style={{ display: "flex", gap: "10px" }}
                >
                  {rows.length > 0 && (
                    <button
                      className="clear-btn"
                      onClick={clearAllRows}
                      style={{
                        backgroundColor: "#dc3545",
                        color: "#fff",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Clear All
                    </button>
                  )}
                  <button className="add-btn" onClick={addRow}>
                    <span>+</span> Add Section
                  </button>
                </div>
              </div>

              <div className="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th>Section</th>

                      <th>Stitches</th>
                      <th>Heads</th>

                      <th>Cost</th>
                      <th style={{ width: "50px" }}></th>
                    </tr>
                  </thead>

                  <tbody>
                    {calc.rows.map((r, i) => (
                      <tr
                        key={i}
                        style={{ position: "relative" }}
                        data-aos="fade-up"
                        data-aos-delay={i * 80}
                      >
                        {" "}
                        {/* Keeps elements bounded inside this row */}
                        <td>
                          <input
                            className="table-input"
                            value={r.section}
                            onChange={(e) =>
                              updateRow(i, "section", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="table-input text-right"
                            type="text"
                            // value={r.stitch}
                            placeholder="0"
                            onChange={(e) =>
                              updateRow(i, "stitch", e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="table-input text-right"
                            type="text"
                            // value={r.heads}
                            placeholder="0"
                            onChange={(e) =>
                              updateRow(i, "heads", e.target.value)
                            }
                          />
                        </td>
                        <td
                          className="cost-cell"
                          style={{ paddingRight: "10px" }}
                        >
                          ₹{r.cost.toFixed(2)}
                        </td>
                        {/* Explicitly styled Table Data cell to avoid external CSS breaking positions */}
                        <td
                          style={{
                            width: "80px",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => removeRow(i)}
                            title="Remove row"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "transparent",
                              color: "#dc3545",
                              border: "none",
                              fontWeight: "800",
                              cursor: "pointer",
                              fontSize: "20px",

                              lineHeight: "1",
                            }}
                          >
                            <i className="bi bi-x-circle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}

                    {calc.rows.length === 0 && (
                      <tr>
                        <td
                          colSpan="7"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            color: "#888",
                          }}
                        >
                          No sections added. Click "Add Section" to get started.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* SUMMARY */}
            <div
              className="summary-box"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <h3>Summary Overview</h3>
              <div className="summary-cards-grid">
                <div
                  className="card highlight"
                  data-aos="flip-left"
                  data-aos-delay="300"
                >
                  <span className="card-label">Total Cost</span>
                  <h2 className="card-value highlight-value">
                    ₹{calc.totalCost.toFixed(2)}
                  </h2>
                </div>
                <div
                  className="card"
                  data-aos="flip-right"
                  data-aos-delay="450"
                >
                  <span className="card-label">Total Meter</span>
                  <h4 className="card-value">
                    {calc.totalMeter.toFixed(2)} <small>Mtr</small>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HorizontalAds />
    </div>
  );
}
